<template>
  <div class="container-fluid">
    <div class="card-body">
      <b-card>
        <b-tabs
          pills
          :horizontal="windowWidth < 768"
          :vertical="windowWidth > 768"
          :nav-wrapper-class="windowWidth > 768 ? 'w-25' : 'w-100'"
          fill
        >
          <Cliente />
          <Servicos />
          <Faturamento />
          <Informacoes />
        </b-tabs>
      </b-card>
      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div v-if="canSaveOrcamento">
              <div class="form mb-5">
                <button
                  v-if="store.currentTab !== 0"
                  class="btn btn-secondary font-weight-bold mr-2"
                  @click="handlePrevious"
                >
                  Anterior
                </button>
                <button
                  v-if="store.isUpdate && store.currentTab !== 3"
                  class="btn btn-primary font-weight-bold mr-4"
                  @click="handleNext"
                >
                  Proximo
                </button>
                <button
                  ref="submit_contrato_servicos"
                  class="btn btn-primary font-weight-bold"
                  @click="salvarContratoServicos"
                >
                  Salvar
                </button>
                <button
                  class="btn btn-clean font-weight-bold"
                  @click="confirmCancel('contratosServicos')"
                >
                  Cancelar
                </button>
              </div>
            </div>
            <div v-else>
              <button
                :disabled="store.currentTab === 0"
                class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious"
              >
                Anterior
              </button>
              <button
                class="btn btn-primary font-weight-bold"
                @click="handleNext"
              >
                Proximo
              </button>
              <button
                class="btn btn-clean font-weight-bold"
                @click="confirmCancel('contratosServicos')"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import Cliente from "./componentes/ClienteTab.vue";
import Servicos from "./componentes/ServicosTab.vue";
import Informacoes from "./componentes/Informacoes.vue";
import Faturamento from "./componentes/FaturamentoTab.vue";
import { store } from "../storeContratos";

export default {
  name: "app-ordem-compra-form",
  props: {},
  directives: {
    mask,
  },
  data() {
    return {
      store,
      contratoId: null,
      windowWidth: window.innerWidth,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    Cliente,
    Servicos,
    Faturamento,
    Informacoes,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (this.$route.params.contratoData.id_contrato_fatura) {
      this.contratoId = this.$route.params.contratoData.id_contrato_fatura;
    }
    this.getDataInit();

    this.store.currentTab = 0;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {},
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSair() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "contratosServicos" });
          }
        });
    },
    async salvarContratoServicos() {
      this.addLoadingToButton("submit_contrato_servicos");
      if (Object.keys(this.$route.params).length !== 0) {
        const { id_contrato_fatura } = this.$route.params.contratoData;
        const data = this.formatDataToSendToContratoApi(
          this.store.formCliente,
          this.store.formServicos,
          this.store.formFaturamento,
          this.store.formInformacoes
        );
        try {
          await this.$http.post("/contrato-fatura/update", {
            id_contrato_fatura,
            ...data,
          });
          this.$toast.success("Contrato editado com sucesso!");
          this.$router.push({ name: "contratosServicos" });
        } catch (error) {
          this.$toast.error("Erro ao editar Contrato!");
        }
      } else {
        try {
          const data = this.formatDataToSendToContratoApi(
            this.store.formCliente,
            this.store.formServicos,
            this.store.formFaturamento,
            this.store.formInformacoes
          );
          if (this.contratoId) {
            await this.$http.post("/contrato-fatura/update", {
              id_contrato_fatura: this.contratoId,
              ...data,
            });
          } else {
            const { id_contrato_fatura } = await this.$http.post(
              "/contrato-fatura/create",
              data
            );
            this.contratoId = id_contrato_fatura;
          }
          this.$toast.success("Contrato salvo com sucesso!");
          this.$router.push({ name: "contratosServicos" });
        } catch (error) {
          this.$toast.error("Erro ao salvar Contrato");
          console.log(error);
        }
      }
      this.removeLoadingToButton("submit_contrato_servicos");
    },
    handleNext() {
      if (this.store.currentTab === 4) return;
      this.store.currentTab++;
    },
    handlePrevious() {
      if (this.store.currentTab === 0) return;
      this.store.currentTab--;
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    canSaveOrcamento() {
      return this.store.currentTab === 3 || this.store.isUpdate;
    },
  },
  created() {
    this.store.currentTab = 0;
    this.store.isUpdate = false;
    if (Object.keys(this.$route.params).length !== 0) {
      const { id_contrato_fatura } = this.$route.params.contratoData;
      this.contratoId = id_contrato_fatura;
      this.store.isUpdate = true;
    }
  },
};
</script>
